export const buildLandingPath = (locale, segment) => {
  const path = segment.replace(/^\//, '')

  if (locale === 'ru') {
    return `/${path}`
  }

  return `/${locale}/${path}`
}
